import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { ProductDetailDrawer } from '../../ProductDetailDrawer/ProductDetailDrawer.js';
import { ProductDetailSpecificationDrawerCTA } from './components/ProductDetailSpecificationDrawerCTA/ProductDetailSpecificationDrawerCTA.js';
import { SpecificationListItem } from './components/SpecificationListItem/SpecificationListItem.js';

const ProductDetailSpecification = ({ className , items  })=>{
    const { getLabel  } = useIntl();
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    const title = getLabel('products.detail.specifications.title');
    /*
  The feature flag isPdpDrawerLayoutEnabled is temporary
  and will be removed once we migrate a number of product detail assets
  to render inside drawer component.
  */ return isPdpDrawerLayoutEnabled ? /* the new version */ /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-specification', className),
        "aria-label": title,
        "data-t": "product-detail-specification"
    }, /*#__PURE__*/ React.createElement(SpecificationsInDrawer, {
        title: title,
        items: items
    })) : /* the old version */ /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-specification', className),
        "aria-label": title,
        "data-t": "product-detail-specification"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "product-detail-specification__title"
    }, title), /*#__PURE__*/ React.createElement(ProductDetailSpecificationList, {
        title: title,
        items: items
    }));
};
const SpecificationsInDrawer = ({ title , items ,  })=>{
    return /*#__PURE__*/ React.createElement(ProductDetailDrawer, {
        "data-t": "specification-drawer",
        title: title,
        shouldMountContent: true,
        ctaButton: /*#__PURE__*/ React.createElement(ProductDetailSpecificationDrawerCTA, {
            title: title
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-specification-in-drawer"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecificationList, {
        title: title,
        items: items
    })));
};
const ProductDetailSpecificationList = ({ title , items , className ,  })=>{
    return /*#__PURE__*/ React.createElement("dl", {
        className: classnames('product-detail-specification__list', className),
        "aria-label": title,
        "data-t": "product-detail-specification-list"
    }, items.map(({ key , label , value  })=>/*#__PURE__*/ React.createElement(SpecificationListItem, {
            key: key,
            label: label,
            value: value
        })
    ));
};

export { ProductDetailSpecification };
//# sourceMappingURL=ProductDetailSpecification.js.map
